import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable()
export class SiteResolverService {
  public domain: string;
  public path: string;
  public site = 'kastor';

  constructor(private location: Location) {
    this.path = this.location.path();
    const url = window.location.href;
    const domainAndApp = url.replace(this.path, '');

    if (url.indexOf('kastor') !== -1) {
      this.site = 'kastor';
    }

    if (url.indexOf('kiungo') !== -1) {
      this.site = 'kiungo';
    }

    this.domain = this.getDomain(domainAndApp);
  }

  protected getHostName(url) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      return match[2];
    } else {
      return null;
    }
  }

  protected getDomain(url) {
    const hostName = this.getHostName(url);
    let domain = hostName;

    if (hostName != null) {
      const parts = hostName.split('.').reverse();
      if (parts != null && parts.length > 1) {
        domain = parts[1] + '.' + parts[0];

        if (hostName.toLowerCase().indexOf('.co.uk') !== -1 && parts.length > 2) {
          domain = parts[2] + '.' + domain;
        }
      }
    }
    return domain;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/site-resolver.service.ts